module.exports = __webpack_public_path__ + "static/media/font-webfont.415e6e33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/font-webfont.svg
// module id = 246
// module chunks = 0